import { ComboBox } from '@/components/ui/combo-box';
import type { Option } from '@/components/ui/combo-box';
import { useTriggerGraphAction } from '@/hooks/use-trigger-graph-action';
import { useState } from 'react';
import type { Headers } from './edit-widget';
interface Chain extends Option {
  events: Option[];
}

export function ChainTriggerForm({
  chains,
  headers,
  nodeFormData,
}: {
  chains: Option[];
  headers: Headers;
  nodeFormData: Record<string, any>;
}) {
  const triggerGraphActionMutation = useTriggerGraphAction();
  const [selectedChain, setSelectedChain] = useState<Chain | null>(null);
  const [selectedChainEvent, setSelectedChainEvent] = useState<Option | null>(
    null
  );

  function handleTriggerGraphAction() {
    triggerGraphActionMutation.mutate({
      data: {
        event: selectedChainEvent?.value,
        object: nodeFormData,
        headers: headers,
        triggeredChainUuid: selectedChain?.value,
      },
    });
  }

  return (
    <div className="flex gap-2.5">
      <div className="flex-1">
        <ComboBox
          options={[...(chains ?? [])]}
          onChange={(value) => {
            setSelectedChain(value as Chain);
            setSelectedChainEvent((value as Chain)?.events?.[0] ?? null);
          }}
          placeholder="Select chain..."
          name="chain"
          wrapText={true}
        />
      </div>
      <div className="flex-1">
        <ComboBox
          options={[...(selectedChain?.events ?? [])]}
          onChange={(value) => setSelectedChainEvent(value as Chain)}
          value={selectedChainEvent}
          placeholder="Select event..."
          name="chainEvents"
          wrapText={true}
        />
      </div>
      <button
        onClick={handleTriggerGraphAction}
        type="button"
        className="inline-flex justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 mt-1"
      >
        Trigger
      </button>
    </div>
  );
}
